// Role permission hierarchy (higher = more permissions)
export const ROLE_PERMISSIONS = {
    owner: 4,
    admin: 3,
    viewer: 2,
    member: 1, // Synced from media server, no Tracearr login until promoted
    disabled: 0,
    pending: 0,
};
// Roles that can log into Tracearr
export const LOGIN_ROLES = ['owner', 'admin'];
// Role helper functions
export const canLogin = (role) => LOGIN_ROLES.includes(role);
export const hasMinRole = (userRole, required) => ROLE_PERMISSIONS[userRole] >= ROLE_PERMISSIONS[required];
export const isOwner = (role) => role === 'owner';
export const isActive = (role) => canLogin(role);
/** Supported media types */
export const MEDIA_TYPES = [
    'movie',
    'episode',
    'track',
    'live',
    'photo',
    'trailer',
    'unknown',
];
/**
 * Default values for stream detail fields (all null).
 * Use with spread operator for test fixtures and initial values.
 */
export const DEFAULT_STREAM_DETAILS = {
    sourceVideoCodec: null,
    sourceAudioCodec: null,
    sourceAudioChannels: null,
    sourceVideoWidth: null,
    sourceVideoHeight: null,
    sourceVideoDetails: null,
    sourceAudioDetails: null,
    streamVideoCodec: null,
    streamAudioCodec: null,
    streamVideoDetails: null,
    streamAudioDetails: null,
    transcodeInfo: null,
    subtitleInfo: null,
};
/** Ordered restore phases (excludes 'failed') for progress UI rendering. */
export const RESTORE_PHASES = [
    'validating',
    'creating_restore_point',
    'shutting_down',
    'restoring_database',
    'running_migrations',
    'rebuilding_aggregates',
    'restarting',
    'complete',
];
//# sourceMappingURL=types.js.map